import * as React from "react";

import {Dimmer, Loader} from "semantic-ui-react";

import Button from "../../../components/Button";

interface IMODConfirmTabProps {
    loaderActive: boolean;
    numberOfOptions: number;
    t: reactI18Next.TranslationFunction;
    backAction: () => void;
    onSubmit: () => void;
}

export const MODConfirmTab = (props: IMODConfirmTabProps) => {

    return (
        <>
            {props.loaderActive &&
            <Dimmer active={props.loaderActive}>
                <Loader>{props.t("PSL_MULTI_DLT:TRIGGER_UPDATE_MSG")}</Loader>
            </Dimmer>
            }
            <div style={{marginBottom: '20px', fontSize: '16px'}}>
                <p>
                    {props.t("PSL_MULTI_DLT:CONFIRM_NOTICE") + ' - '}
                    <b>
                        {props.numberOfOptions + ' '}
                        {props.t("PSL_MULTI_DLT:OPTIONS")}
                    </b>
                </p>
                <p>
                    {props.t("PSL_MULTI_DLT:CONFIRM_AGREEMENT")}
                </p>
            </div>

            <div className="psl-mod-navigation-buttons">
                <Button
                    icon={'arrow right'}
                    style={{float: 'right'}}
                    onClick={props.onSubmit}
                />
                <Button
                    icon={'arrow left'}
                    onClick={props.backAction}
                />
            </div>
        </>
    );
};


// WEBPACK FOOTER //
// ./src/views/OptionsView/multipleOptionDeletionDialog/MODConfirmTab.tsx